import classNames from "classnames";
import { Form, Formik } from "formik";
import React from "react";
import style from "../../assets/css/components/Form/Form.module.css";
import { AddFoulInitialState, AddFoulValidationSchema } from "../../utils/foul";
import Button from "../Button/Button";
import Input from "../Input/Input";
import InputSelect from "../Input/InputSelect";

import { socket } from "../../config/socket";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
const MySwal = withReactContent(Swal);

function FormFoul({ idMatch, typeMatch, teams, playersLocal, playersVisit }) {
  const card = [
    { value: "2", label: "Sin tarjeta" },
    { value: "3", label: "Tarjeta amarilla" },
    { value: "4", label: "Tarjeta rojo" },
  ];

  const handleSubmit = async (values) => {
    console.log(values);
    const { team, time, player, card, description } = values;
    let playersTeam = [];

    if (team === "1") {
      playersTeam = playersLocal;
    } else {
      playersTeam = playersVisit;
    }

    const objIndex = playersTeam.findIndex((obj) => obj.value === player);
    const title = playersTeam[objIndex].label;

    if (values.card !== "2" && typeMatch !== "amistoso") {
      socket.emit("addCard", { player, type: card }, (cardFoul) => {
        MySwal.fire("Tarjeta asignada");
        // console.log(cardFoul);
      });
    }

    socket.emit(
      "addStory",
      { idMatch, team, time, title, description, type: card },
      (story) => {
        MySwal.fire("story agregado");
        // console.log(story);
      }
    );
  };

  return (
    <Formik
      initialValues={AddFoulInitialState}
      validationSchema={AddFoulValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleChange, touched, values }) => (
        <Form className={classNames(style.form, style.formLive)}>
          <div className={classNames(style.formColumn, style.twoColumn)}>
            <InputSelect
              error={touched.team && errors.team}
              name="team"
              title="Falta del equipo"
              options={teams}
              onChange={(selectedOption) => {
                handleChange("team")(selectedOption.value);
              }}
            />
            <Input name="time" title="Minuto de juego" type="number" />
            <InputSelect
              error={touched.player && errors.player}
              name="player"
              title="Jugador"
              options={
                values.team === "1"
                  ? playersLocal
                  : values.team === "2"
                  ? playersVisit
                  : []
              }
              onChange={(selectedOption) => {
                handleChange("player")(selectedOption.value);
              }}
            />
            <InputSelect
              error={touched.card && errors.card}
              name="card"
              title="Tarjeta"
              options={card}
              onChange={(selectedOption) => {
                handleChange("card")(selectedOption.value);
              }}
            />
            <div className={style.inputLong}>
              <Input name="description" title="Descripción" />
            </div>
          </div>
          <Button text="Guardar" />
        </Form>
      )}
    </Formik>
  );
}

export default FormFoul;
